export default function SciPy_Exercises() {
  return (
    <div>
      <h1>SciPy Exercises</h1>
    </div>
  );
}
